var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstashow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.78,
    height: 24.78,
    viewBox: "0 0 24.78 24.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_854",
    "data-name": "Rectangle 854",
    width: 24.78,
    height: 24.78,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#d63f94",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1689",
    "data-name": "Group 1689",
    transform: "translate(-347 -311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232",
    transform: "translate(347 311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M12.39.75a11.2,11.2,0,0,0-2.024.182",
    fill: "none",
    stroke: "#d63f94",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M3.6,4.773a11.615,11.615,0,0,0-1.432,2.05",
    fill: "none",
    stroke: "#d63f94",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M19.475,3.159A11.637,11.637,0,1,1,1.028,9.86",
    fill: "none",
    stroke: "#d63f94",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M7.835,1.676A11.268,11.268,0,0,0,5.821,2.784",
    fill: "none",
    stroke: "#d63f94",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M12.39,4.292v8.1l4.049,4.049",
    fill: "none",
    stroke: "#d63f94",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M18.969,6.823V2.774h4.049",
    fill: "none",
    stroke: "#d63f94",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstashow);
export default __webpack_public_path__ + "static/media/instashow.13050a154c4aba25b19253ac247a2d1d.svg";
export { ForwardRef as ReactComponent };